import React, { useState, useEffect } from "react";

import iconBlocked from "../../assets/images/noun-blocked.png";
import iconPdf from "../../assets/images/noun-pdf.png";
import iconCompare from "../../assets/images/noun-compare.png";
import iconDuplicate from "../../assets/images/noun-duplicate.png";

import iconBlockedActive from "../../assets/images/noun-blocked-active.png";
import iconPdfActive from "../../assets/images/noun-pdf-active.png";
import iconCompareActive from "../../assets/images/noun-compare-active.png";
import iconDuplicateActive from "../../assets/images/noun-duplicate-active.png";

import iconCheck from "../../assets/images/icon-check.png";
import iconArrowDown from "../../assets/images/arrow-down.png";
import { PDFExport } from "@progress/kendo-react-pdf";
import DetailEval from "../../pages/QualityMonotoring/DetailEval";
import "bootstrap/dist/css/bootstrap.css";
import "./popover.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  exportPdfDetailEval,
  closeDetailEval,
} from "../../redux/actions/design";
import { useDispatch, useSelector } from "react-redux";
import { getOneEval } from "../../redux/actions/evaluation";
import axios from "axios";
import DetailGrille from "../../pages/QualityMonotoring/DetailGrille";


const PopoverActionGrille =  (props) => {
    const dispatch = useDispatch();
    const pdfExportComponent = React.useRef(null);
    const { dataevals ,datameevals,dataeval} = useSelector((state) => state.evaluation);
    const [ array ,setArray]=useState([])
  
    
  const handleClickselec = () => {
  
      
  
   
    for(let i=0;i<props.count.length;i++){
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/grille/one/${props.count[i]}`)
      .then((res)=>{
        array.push(res.data.data)
        setArray([...array])
        
        if (pdfExportComponent.current) {
          
  
          pdfExportComponent.current.save();
        }
      })
    }
   
        
      
        
  
      
     
    
    };
    const popover = (
      <Tooltip id="tooltip-bottom-action">
        <div className="row">
          <div className="col-3 align-it">
            <div id="cercle-tooltip-action">
              <img
                alt=""
                src={iconCompare}
                onMouseOver={(e) => (e.currentTarget.src = iconCompareActive)}
                onMouseOut={(e) => (e.currentTarget.src = iconCompare)}
                width="20"
                height="20"
              />
            </div>
            <span id="label-comparer">Comparer</span>
          </div>
          <div className="col-3 align-it">
            <div id="cercle-tooltip-action">
              <img
                alt=""
                src={iconDuplicate}
                onMouseOver={(e) => (e.currentTarget.src = iconDuplicateActive)}
                onMouseOut={(e) => (e.currentTarget.src = iconDuplicate)}
                width="20"
                height="20"
              />
            </div>
            <span id="label-comparer">Dupliquer</span>
          </div>
          <div className="col-3 align-it">
            <div id="cercle-tooltip-action">
              <img
                alt=""
                src={iconPdf}
                onMouseOver={(e) => (e.currentTarget.src = iconPdfActive)}
                onMouseOut={(e) => (e.currentTarget.src = iconPdf)}
                width="20"
                height="20"
                onClick={handleClickselec}
              />
            </div>
            <span id="label-comparer">Enregistrer PDF</span>
          </div>
          <div className="col-3 align-it">
            <div id="cercle-tooltip-action">
              <img
                alt=""
                src={iconBlocked}
                onMouseOver={(e) => (e.currentTarget.src = iconBlockedActive)}
                onMouseOut={(e) => (e.currentTarget.src = iconBlocked)}
                width="20"
                height="20"
              />
            </div>
            <span id="label-comparer">Désactiver</span>
          </div>
        </div>
      </Tooltip>
    );
  
    return (
      <>
        <div className="container-actions row mr-2 d-flex justify-content-around ">
          <div
            style={{ fontFamily:'Gilroy', borderRight: "solid 1px #E6DCF7" }}
            className="container-selections align-self-center"
          >
            <img
              style={{ marginRight: "5px" }}
              src={iconCheck}
              alt="Logo"
              height="15"
            />
            <span style={{ fontSize: "12px" }}>
              {" "}
              {props.count.length} sélection{props.count.length > 1 ? <span>s</span> : null}{" "}
            </span>
          </div>
          <div style={{ cursor: "pointer" }} className="container-selections">
            <OverlayTrigger
              trigger="click"
              placement="bottom-end"
              rootClose
              overlay={popover}
            >
              <div 
             
              >
                <span style={{ fontSize: "13px", fontFamily:'Gilroy-Semibold', color:'#5800E2', marginRight: "5px" }}>
                  Action
                </span>
                <img src={iconArrowDown} alt="Logo" height="6" />
              </div>
            </OverlayTrigger>
          </div>
    
      <div
          style={{
            position: "absolute",
            left: "-1000px",
            top: 0,
          }}
        >
         {array.map((e,key)=>(
           
             <PDFExport
              //  pageTemplate={PageTemplate}
          paperSize={"A4"}
            fileName={`ROUNDESK_${e?.name}.pdf`}
            scale={1}
            margin="0cm"
            title=""
            subject=""
            proxyData={array}
            keywords=""
            ref={pdfExportComponent}
            >
  
            <div
              style={{
                height: "800vh",
                width: "100%",
                padding: "none",
             
                margin: "auto",
                overflowX: "hidden",
                overflowY: "hidden"
              }}
            > 
              <DetailGrille elmineDivision={true}   selected ={true} e={e} key={key}/>
            </div>
          </PDFExport>
         )
         )}
             
          
      
        </div> 
       
     
          
        </div>
      </>
    );
  };
export default PopoverActionGrille